import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Renderer2,
  AfterContentInit,
  AfterViewInit,
} from "@angular/core";
import { RenderedService } from "../../rendered.service";
import { DataModelService } from "@services/data-model.service";
import { CourseService } from "@scaffold/services/course.service";
import { MoveListService } from "@scaffold/services/move-list.service";
import { ViewsService } from "@services/views.service";
import { ItemsService } from "@scaffold/services/items.service";
import { AddDataComponent } from "@scaffold/dialogs/add-data/add-data.component";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { ViewUpdateService } from "@scaffold/services/view-update.service";

import { NbDialogService, NbDialogRef } from "@nebular/theme";
import {
  itemActiveStateFilter,
  searchObject,
} from "../../../../../framework/search-bar/search-bar.component";
import { Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TranslationService } from "@services/translation.service";

@Component({
  selector: "scaffold-list",
  templateUrl: "./list.component.html",
  styleUrls: ["../../rendered.component.scss", "./list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  @Input() view: any[] = [];
  public destroy$: Subject<boolean> = new Subject<boolean>();
  item_data = [];
  created;
  loading
  listUrl;
  rootItem;
  listSearchOptions = [];
  listSearchTerm;
  listSearchValue;
  listPageNumber = 0;
  listItemsPerPage = 10;
  listTotalNumberOfItems;
  init = false;
  listTypes = [];
  itemToDuplicate;
  totals = {};
  columnValues = [];
  searchData;
  menuItems = [];
  recentCountLoad = 1;
  activeStateFilter: itemActiveStateFilter = itemActiveStateFilter.active;
  _listObservable: Subscription
  _perPage = 10;
  isLoading: boolean;
  set perPage(count) {
    console.log(count);
    this._perPage = count;
    this.update();
  }
  get perPage() {
    return this._perPage;
  }
  itemCount = 0;
  private _active = 1;
  set active(page: number) {
    console.log(page);
    this._active = page;
    this.getListItems();
    this.redraw();
  }
  get active(): number {
    return this._active;
  }

  listTitleChanges = [];

  dialogRef: NbDialogRef<any>;

  inline_data;

  constructor(
    private translationService:TranslationService,
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private courseService: CourseService,
    public moveList: MoveListService,
    private dialog: NbDialogService,
    private itemsService: ItemsService,
    private viewUpdate: ViewUpdateService,
    private renderer: Renderer2,
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    // this.getAddMenu(this.item.list_view);
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.update();
      });
    this.listTotalNumberOfItems = this.view?.length;

    // Grab the types for this list, will need to pass to back end for sorting.
    // if (this.item.list_view.push) {}
    this.item.list_view.forEach((type, i) => {
      this.listTypes.push(type.name);
    });

    // listen for changes to a list
    this.viewUpdate
      .registerListUpdate()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        let isType = false;
        // check if the list update was for the list type
        if (data && data.list_type === "list") {
          // check if the list updated contains item of this type
          if (this.item.list_view.push) {
            this.item.list_view.forEach((type, i) => {
              if (type.name == data.type) {
                isType = true;
              }
            });
          } else {
            if (this.item.list_view == data.type) {
              isType = true;
            }
          }
          if (isType) {
            if (data.removed) {
              if (this.item && this.item.list_view) {
                let found = -1;
                this.view.forEach((v, i) => {
                  if (v.id == data.removed) {
                    found = i;
                  }
                });
                if (found >= 0) {
                  this.view.splice(found, 1);
                  this.update();
                  this.getListItems();
                } else if (this.info.children) {
                  this._listObservable =
                  this.courseService
                    .get(
                      this.info.type +
                        "/" +
                        this.info.id +
                        "/" +
                        this.item.type +
                        "/" +
                        this.item.id +
                        "?mode=" +
                        (this.item.list_mode || "list")
                    )
                    .subscribe((updated) => (this.info.children = updated));
                }
              }
            } else if (data.added) {
              console.log("added", data);
              if (
                ((!this.info || !this.info.id) && !data.parent_id) ||
                (this.info && this.info.id === data.parent_id)
              ) {
                this.getListItems();
              }
            } else {
              if (
                ((!this.info || !this.info.id) && !data.parent_id) ||
                (this.info && this.info.id === data.parent_id)
              ) {
                if (data.placeholder && data.placeholder.position) {
                  this.view.splice(
                    data.placeholder.position - 1,
                    0,
                    data.placeholder
                  );
                } else {
                  console.log("Preview Push");
                  this.view.push(data.placeholder);
                }
                this.redraw();
                console.log(this.view);
              }
            }
          }
        }
      });

    this.moveList
      .moveUpdatesListener()
      .pipe(takeUntil(this.destroy$))
      .subscribe((moveItem) => {
        if (this.view && moveItem) {
          for (let i = 0; i < this.view.length; i++) {
            const child = this.view[i];

            if (moveItem.id == child.id) {
              // The item that wants to move is in this list
              console.log("Found Item");
              this.moveList.setMoveItem(this.info.id, child, i);
              this.renderedService.triggerUpdate("moving an item");
              break;
            }
          }
        }
      });

    this.moveList
      .duplicateUpdatesListener()
      .pipe(takeUntil(this.destroy$))
      .subscribe((moveItem) => {
        if (moveItem) {
          if (this.view) {
            if (this.isType(moveItem.type)) {
              this.itemToDuplicate = moveItem;
            }
          }
        } else {
          this.itemToDuplicate = undefined;
        }
        console.log(this.itemToDuplicate, this.moveList.movingItem);
        console.log(this.item.list_view);
        this.redraw();
      });

    if (this.item.inline_create) {
      this.inline_data = {
        parent: this.info,
        type: this.item.list_view[0],
        data: this.data,
        mode: this.item.create_mode,
        defaults: this.item.new_defaults,
      };
    }

    // console.log(this.item.list_content)
    if (!this.item.hasOwnProperty("list_content")) {
      if (!this.item.search_load) {
        console.log("GET LIST");
        this.perPage = this.item.pageCounts?.[0]?.count ||this._perPage;
        this.listUrl = this.generateListUrl();
        this.getListItems();
      }
    } else {
      this.listUrl = this.generateListUrl();
      if (this.item.list_content.listItems) {
        this.view = this.item.list_content.listItems;
        this.perPage = this.item.list_content.perPage || this.item.pageCounts?.[0]?.count || 10;
        this.itemCount = this.item.list_content.totalItems;
        this.listTotalNumberOfItems = this.item.list_content.totalItems;
        this.getCountLabel();
      } else {
        this.view = [this.item.list_content];
      }
      this.update();
    }
    /* if (this.view) {
       this.view.forEach(i => {
         let titleUpdates = this.itemsService.registerItem(i).subscribe(d => {
           if (d.hasOwnProperty("title")) {
             console.log(this)
             try {
               let val = this.itemsService.get(d, "title");
               i.title = val;
             } catch (e) {
               console.log(e);
             }
             this.redraw();
           }
         });
         this.listTitleChanges.push(titleUpdates);
       })
       *
     }*/
  }



  getAddMenu(items) {
    console.log(items);
    items.forEach((i) => {
      i.title = i.name;
      i.data = { info: this.info, type: i.name };
    });
  }

  onIntersection(
    { target, visible }: { target: Element; visible: boolean },
    item
  ): void {
    if (visible) {
      this.renderer.setStyle(target, "height", "auto");
      this.renderer.setStyle(target.children[0], "display", "block");
    } else {
      const height = target.clientHeight + "px";
      this.renderer.setStyle(target, "height", height);
      this.renderer.setStyle(target.children[0], "display", "none");
    }
  }
  getContext() {
    console.log("CONTEXT: " + this.item.parent_context);
    let context;
    if (this.item.parent_context == "specified") {
      if (this.item.specified_type && this.item.value) {
        context = { type: this.item.specified_type, id: this.item.value };
      } else {
        context = null;
      }
    } else if (this.item.parent_context == "all") {
      context = null;
    } else if (this.item.parent_context == "parent") {
      context = { type: "courses", id: this.courseService.id };
      if (this.item.get_all) {
        context.get_all = true;
      }
    } else {
      context = { type: this.info.type, id: this.info.id };
    }
    return context;
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  isType(type) {
    let match = false;
    if (this.item && this.item.list_view) {
      this.item.list_view.forEach((v, i) => {
        if (v.name === type) {
          match = true;
        }
      });
    }
    return match;
  }

  /**
   * Generates url to load item for this list
   * */
  generateListUrl(): string {
    let base;
    if (this.item.list_view.push && this.item.list_view.length > 0) {
      base = this.item.list_view[0].name;
    } else {
      base = this.item.list_view;
    }
    let url = "";

    if (this.info) {
      if (this.info.type && this.info.id) {
        url = this.info.type + "/" + this.info.id + "/" + base;
      } else {
        url = "" + base;
      }
    }
    url += `?mode=${this.item.list_mode || "list"}`;
    return url;
  }

  loadMore() {
    this.active +=1
  }
  /**
   *Get a filtered list of item in this list based on any search settting
   * */
  getListItems() {
    this.isLoading = true
    if (this._listObservable) {
      this._listObservable.unsubscribe();
    }
    // this.loading=true
    let query = "";
     if (this.item.list_view.push) {
      if (this.item.list_view.length > 1) {
        query = "&additional=";
        this.item.list_view.forEach((v, i) => {
          if (i > 0) {
            query += v.name;
            if (i < this.item.list_view.length - 1) {
              query += ",";
            }
          }
        });
      }
    }
    if (this.item.load_recent) {
      query += "&recent=" + this.item.recent_count * this.recentCountLoad;
    } 
    else if(this.item.load_more){
      query += `&pageNumber=${this.active-1}&perPage=${10}`
    }
    
    else {
      if (this.item.paginate_results) {
        query += "&pageNumber=" + (this.active - 1);

        if (this.perPage) {
          query += "&perPage=" + this.perPage;
        }
      }
    }
    if (this.searchData && this.searchData.key != null) {
      query +=
        "&searchParam=" +
        this.searchData.key +
        "&searchTerm=" +
        encodeURIComponent(this.searchData.term);
    }
    if (
      (this.item.force_only_active_items ||
        this.item.display_active_state_filter) &&
      this.activeStateFilter
    ) {
      query += `&state=${this.activeStateFilter}`;
    }

    let url = this.generateListUrl();
    // ?mode=list&recent=8
    this._listObservable = this.courseService.get(url + query).subscribe((co) => {
       this.processItems(co);
       this.isLoading = false;
    });
  }

  perPageChange(e) {
    this.listItemsPerPage = e;
    this.perPage = e;
    this.listPageNumber = 0
    this.active = 1
    this.update()
  }

  search(data: searchObject) {
    this.activeStateFilter = data.itemState;

    this.searchData = data;
    this._active = 1;
    this.getListItems();
  }
  processItems(co, initial?) {
    if (!this.view) {
      this.view = [];
    }
    this.listTotalNumberOfItems = co?.hasOwnProperty('totalItems')? co.totalItems: co?.listItems?.length||co?.length||0
    if (co&&Array.isArray(co)) {
      co = { listItems: co };      
    }
    if (co && co?.id) {
      co = { listItems: [co] };
      this.listTotalNumberOfItems = 1;
    }
    console.log(JSON.stringify(this.view.map((i) => i.title)));

    this.view = this?.item?.load_more && this?.active>1? [...this?.view,...co?.listItems]   : co?.listItems||[]

    if (this?.item?.allow_sort) {
      this?.view?.sort((a, b) => parseInt(a.position) - parseInt(b.position));
    }
    this.itemCount = co?.totalItems || co?.listItems?.length;
    this.loading = false;
    this.update();
  }

  getCountLabel() {
    if(!this.listTotalNumberOfItems)return ''
    let label = "";
    if (this.item.paginate_results) {
      let start, end;
      if (this.listTotalNumberOfItems!==null) {
        
        start = Math.min(
          this.active * this.perPage - this.perPage + 1,
          this.listTotalNumberOfItems
        );
        end = Math.min(
          this.active * this.perPage,
          this.listTotalNumberOfItems
        );
      } else {
        start = this.active * this.perPage - this.perPage + 1;
        end = Math.min(
          this.active * this.perPage,
          start + this.view.length
        );
        console.log("Nat a number", this.listTotalNumberOfItems, start, end);
      }
      if (!isNaN(start) && !isNaN(end)) {
        label = `${start} - ${end}`;
      }
      if (this.listTotalNumberOfItems !== null) {
        const of = this.translationService.getTranslatedContent('of','of')
    const items = this.translationService.getTranslatedContent('items','Items')
        label += ` ${of} ${this.listTotalNumberOfItems} ${items}`;
      }
    }
    else if(this.item.load_more){
      const of = this.translationService.getTranslatedContent('of','of')
      const items = this.translationService.getTranslatedContent('items','Items')
      const start = Math.min(
        1,
        this.listTotalNumberOfItems
      );
      const end = Math.min(
        this.active * this.perPage,
        this.listTotalNumberOfItems
      );
      label = `${start} - ${end}`
      if (this.listTotalNumberOfItems) {
        label += ` ${of} ${this.listTotalNumberOfItems} ${items}`;
      }
    }
    
    else if (this.listTotalNumberOfItems && this.listTotalNumberOfItems > 0) {
      const items = this.translationService.getTranslatedContent('items','Items')
      label = `${this.listTotalNumberOfItems} ${items}`;
    }
    return label;
  }

  findInView(item) {
    let found = -1;
    this.view.forEach((v, i) => {
      if (item.id === v.id) {
        found = i;
      }
    });
    if (found < 0) {
      this.view.forEach((v, i) => {
        if (!v.id) {
          found = i;
        }
      });
    }
    console.log("Found", item.title, found);
    return found;
  }

  // processItemsBak(co, initial?) {
  //   this.listTotalNumberOfItems = null;
  //   this.view = [];
  //   const existing = [];
  //   this.rootItem = this;
  //   const list_items = {
  //   };

  //   const allList = [];
  //   if (co && co.totalItems) {
  //     this.listTotalNumberOfItems = co.totalItems;
  //   }
  //   if (co && co.push) {

  //     co.listItems = co;
  //   }
  //   if (co && co.id) {

  //     co = { listItems: [co] };
  //   }
  //   //   list_items[this.courseService.id] = {};
  //   if (co && co.listItems) {
  //     if (co.listItems.push) {
  //       if (this.item.allow_sort) {
  //         co.listItems.sort((a, b) => parseInt(a.position) - parseInt(b.position));
  //       }
  //       co.listItems.forEach((v, i) => {
  //         if (v) {
  //           if (initial) {
  //             v.rootItem = this;
  //             v.rootView = this.item;
  //           } else {
  //             v.rootItem = this.info.rootItem;
  //             v.rootView = this.info.rootView;
  //           }
  //           list_items[v.id] = v;
  //           // if (this.item && this.item.type === 'data_table') {
  //           //     this.item.columns.forEach(col => {
  //           //         var found = false;
  //           //         this.totals[col.label].forEach(dat => {
  //           //             if (dat.value == v.data[col.data]) {
  //           //                 found = true;
  //           //                 dat.count++;
  //           //             }
  //           //         })
  //           //         if (!found) {
  //           //             this.totals[col.label].push({ value: v.data[col.data], count: 1 })
  //           //         }
  //           //     });

  //           // }
  //         }
  //       });
  //       /* this.listTitleChanges.forEach(i => {
  //          if (i && i.unsubscribe)
  //            i.unsubscribe();
  //        });*/
  //       co.listItems.forEach((v, i) => {
  //         if (v && existing.indexOf(v.id) < 0) {
  //           existing.push(v.id);
  //           if (list_items[v.parent_id]) {
  //             if (!list_items[v.parent_id].childview) {
  //               list_items[v.parent_id].childview = [];
  //             }
  //             v.parent = list_items[v.parent_id];

  //             list_items[v.parent_id].childview.push(v);
  //             if (this.item.root_list) {
  //               allList.push(v);
  //             }
  //             // }
  //           } else {
  //             v.parent = this.info;
  //             if (!this.item.root_list) {
  //               this.view.push(v);
  //               this.item_data.push({});
  //             } else {
  //               allList.push(v);
  //             }
  //           }
  //         }
  //       });

  //       if (this.item.root_list) {
  //         this.view = allList.sort((a, b) => {
  //           let order = parseInt(a.position) - parseInt(b.position);
  //           if (order === 0) {
  //             if (a.id === b.parent_id) {
  //               order = -1;
  //             }
  //             if (b.id === a.parent_id) {
  //               order = 1;
  //             }
  //           }
  //           return order;
  //         });
  //         /* this.view.forEach(i => {
  //            let titleUpdates = this.itemsService.registerItem(i).subscribe(d => {
  //              if (d.hasOwnProperty("title")) {
  //                //console.log("updating " + this.item.name + " to " + d[this.item.name], ":" + this.item.type + " - " + this.item.name);
  //                try {
  //                  let val = this.itemsService.get(d, "title");
  //                  i.title = val;
  //                } catch (e) {
  //                  console.log(e);
  //                }
  //                this.redraw();
  //              }
  //            });
  //            this.listTitleChanges.push(titleUpdates);
  //          })*/
  //       }
  //     } else {
  //       this.item_data.push({});
  //       this.view = [co.listItems];
  //     }
  //   } else {
  //     this.view = [];
  //   }
  //   // this.triggerUpdate();

  //   // this.cdr.detectChanges();
  //   console.log('Register tab title', this.item);
  //   this.view.forEach(i => {
  //     console.log(i);
  //     const titleUpdates = this.itemsService.registerItem(i).subscribe(d => {
  //       if (d.hasOwnProperty('title')) {
  //         console.log('updating title to ' + d.title, ':' + this.item.type);
  //         console.log(this);
  //         try {
  //           const val = this.itemsService.get(d, 'title');
  //           i.title = val;
  //         } catch (e) {
  //           console.log(e);
  //         }
  //         this.redraw();
  //       }
  //     });
  //     /* this.listTitleChanges.push(titleUpdates);*/
  //   });
  //   this.loading = false;
  //   this.renderedService.triggerUpdate('populated list');

  // }

  pageChanged(event) {
    // console.log(event)
    this.listPageNumber = event.pageIndex;
    this.listItemsPerPage = event.pageSize;
    this.getListItems();
  }

  searchList() {
    this.listPageNumber = 0;
    this.getListItems();
  }

  cancelListMove(ite) {
    this.moveList.requestMove(null);
    this.toggleMenu(false, "hovered", ite);
    this.renderedService.triggerUpdate("cancel move");
  }

  trackByFn(index, item) {
    return item.id; // unique id corresponding to the item
  }
  insertItem(index) {
    // if duplicating
    if (this.itemToDuplicate) {
      console.log("Inserting ", this.itemToDuplicate.id, "at index", index);
      this.createData(
        this.itemToDuplicate.type,
        parent,
        true,
        this.itemToDuplicate.id,
        index + 1,
        [{ key: "copy_from", value: this.itemToDuplicate.id }]
      );
      this.moveList.requestMove(null, true);
      // this.path += "?duplicate=" + this.data.duplicate.id;
    } else {
      // if moving
      if (this.afterCurrent(index)) {
        index--;
      }
      if (this.moveList.movingItem) {
        const data = {
          position: index + 1,
          listTypes: this.listTypes,
        };

        if (this.moveList.listId != this.info.id) {
          data["updatedParent"] = this.info.id;
        }
        console.log(data);
        console.log(this.moveList.movingItem);
        // this.viewsService.saveViewData("/" + this.moveList.movingItem.parent.type + "/" + this.moveList.movingItem.parent.id + "/" + this.moveList.movingItem.type + "/" + this.moveList.movingItem.id, { data: data }).subscribe(d => {
        this.itemsService
          .saveViewData(
            "/" +
              this.moveList.movingItem.type +
              "/" +
              this.moveList.movingItem.id,
            { data: data }
          )
          .subscribe((d) => {
            if (this.info.rootItem) {
              this.info.rootItem.courseService
                .get(this.info.rootItem.listUrl)
                .subscribe((co) => this.info.rootItem.processItems(co, true));
            } else {
              this.courseService
                .get(this.listUrl)
                .subscribe((co) => this.processItems(co, true));
            }
          });

        if (this.moveList.listId != this.info.id) {
          this.redraw();
          this.viewUpdate.triggerListChange({
            list_type: "list",
            type: this.moveList.movingItem.type,
            removed: this.moveList.movingItem.id,
            parent_type: this.info.type,
            parent_id: this.info.id,
          });
        } else {
          /* this.view.splice(index, 0, this.moveList.movingItem);
           this.redraw();*/
        }
        this.moveList.cancelMove();
      }
    }
  }
  log(e) {
    console.log(e);
  }
  initiated() {
    console.log("init");
    this.init = true;
  }

  scrollTo(element: HTMLElement) {
    if (this.init) {
      const headerOffset = 64;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  }
  /*
   *Check if index provided is after the current item selected for move
   * */
  afterCurrent(index) {
    const location = this.view.indexOf(this.moveList.movingItem);
    if (this.moveList && this.moveList.movingItem && location >= 0) {
      if (location <= index) {
        return true;
      }
    }
    return false;
  }

  movingIndex() {
    const index = this.view.indexOf(this.moveList.movingItem);
    return index;
  }

  toggleMenu(open, key, item?) {
    let $this = this;
    if (item) {
      $this = item;
    }
    /* if (open) {
       if ($this['_timeout'])
         clearTimeout($this['_timeout']);*/
    $this[key] = open;
    /*  } else {
       console.log("starting debounce", open)
        if ($this['_timeout'])
          clearTimeout($this['_timeout']);
        $this['_timeout'] = setTimeout(function () {
          $this[key] = open;
          console.log("finish debounce", open);
        }, 200);
      }*/
  }
  addNew(event) {
    console.log(event);
    this.createData(
      event.type,
      this.info,
      this.item.allow_add,
      null,
      event.index,
      event.defaults
    );
  }

  createData(type, parent, add, duplicate?, position?, defaults?) {
    console.log(position);
    let createPosition;
    if (this.item.param && !position) {
      const last = this.view[this.view.length - 1];

      createPosition = ["set_create_position=" + last.position + 1];
    }

    const def = defaults || this.item.new_defaults;

    if (this.item.use_defaults || duplicate || defaults) {
      if (!this.created) {
        this.created = true;

        const default_data = {
          type: type,
          data: {},
        };
        if (position) {
          default_data.data["position"] = position;
        }
        if (def) {
          def.forEach((def) => {
            default_data.data[def.key] = def.value;
          });
        }
        let path = "";
        if (this.info) {
          path += this.info.type + "/" + this.info.id + "/";
        }
        path += type;
        if (duplicate) {
          path += "?duplicate=" + duplicate;
        }
        const placeholder = {
          type: type,

          data: {
            content: [
              {
                type: "text",
                value: default_data.data["title"] || type,
              },
            ],
          },
        };
        if (position) {
          placeholder["position"] = position;
        }
        this.viewUpdate.triggerListChange({
          list_type: "list",
          placeholder: placeholder,
          type: type,
          parent_type: this.info.type,
          parent_id: this.info.id,
        });
        this.itemsService
          .createData(path, default_data, createPosition)
          .subscribe((d) => {
            this.created = false;
            if (this.info) {
              this.viewUpdate.triggerListChange({
                list_type: "list",
                type: type,
                added: d,
                parent_type: this.info.type,
                parent_id: this.info.id,
              });
            }
          });
      }
    } else {
      console.log(parent);
      const data = {};
      if (this.item.param && this.item.req_value) {
        data[this.item.param] = this.item.req_value;
      }
      if (position) {
        data["position"] = position;
      }

      const config: any = {
        dialogClass: "scaffold-wide-dialog",
        context: {
          data: {
            comp: this,
            parent: parent,
            type: type,
            allowAdd: add,
            duplicate: duplicate,
            data: data,
            urlParams: createPosition,
            label: this.item.button_title,
          },
        },
      };

      this.dialogRef = this.dialog.open(AddDataComponent, config);

      this.dialogRef.onClose.subscribe((result) => {});
    }
  }

  getWidth() {
    let width = "";
    if (
      this.item.is_horizontal &&
      this.view.length > 2 &&
      !this.item.prevent_wrap &&
      this.item.column_count
    )
      width = "width:" + 99 / this.item.column_count + "%";
    return width;
  }
}
